var _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Star(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q0c2dLEp_4LHk~8cW2fATa",
    x1: 9.009,
    x2: 38.092,
    y1: 6.36,
    y2: 45.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q0c2dLEp_4LHk~8cW2fATa)",
    d: "M24.913,5.186l5.478,12.288l13.378,1.413c0.861,0.091,1.207,1.158,0.564,1.737l-9.993,9.005 l2.791,13.161c0.18,0.847-0.728,1.506-1.478,1.074L24,37.141l-11.653,6.722c-0.75,0.432-1.657-0.227-1.478-1.074l2.791-13.161 l-9.993-9.005c-0.643-0.579-0.296-1.646,0.564-1.737l13.378-1.413l5.478-12.288C23.439,4.395,24.561,4.395,24.913,5.186z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Star);
export default __webpack_public_path__ + "static/media/icons8-star.1e1c0a25a58a62001c86b425c215c28e.svg";
export { ForwardRef as ReactComponent };